import { render } from "./AppointmentDetails.vue?vue&type=template&id=7684f35e"
import script from "./AppointmentDetails.vue?vue&type=script&lang=js"
export * from "./AppointmentDetails.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./AppointmentDetails.vue?vue&type=style&index=1&id=7684f35e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__